import { getContentfulPageContentForSlug } from '~coreModules/contentful/js/contentful-client';
import { shapeContentfulContentPageResponse } from '~coreModules/contentful/js/contentful-utils';

import { CONTENT_TYPES } from '~modules/contentful/js/contentful-constants';

export const REFERRALS_MODULE_NAME = 'referrals';

export const SET_FRIENDBUY_CLICK = 'SET_FRIENDBUY_CLICK';
export const GET_REFERRAL_CONTENT = 'GET_REFERRAL_CONTENT';
export const SET_REFERRAL_CONTENT = 'SET_REFERRAL_CONTENT';

export default {
    namespaced: true,

    state: () => ({
        friendbuyClick: false,
        contentfulContent: null,
    }),

    /* eslint-disable no-param-reassign */
    mutations: {
        [SET_FRIENDBUY_CLICK](state, newClick) {
            state.friendbuyClick = newClick;
        },
        [SET_REFERRAL_CONTENT](state, contentfulContent) {
            state.contentfulContent = contentfulContent;
        },
    },

    /* eslint-enable no-param-reassign */
    /* eslint-disable no-undef */
    actions: {
        [GET_REFERRAL_CONTENT]({ commit }, slug) {
            return getContentfulPageContentForSlug({
                contentfulSvc: this.$contentfulSvc,
                contentType: CONTENT_TYPES.CONTENT_SLOT,
                slug,
                isTimed: false,
            }).then((response) => {
                const shapedContent = shapeContentfulContentPageResponse(response);
                commit(SET_REFERRAL_CONTENT, shapedContent);
            }).catch((error) => {
                this.$logger.debugError(`Contentful content not found for slug ${slug}: `, error);
                return Promise.reject(error);
            });
        },
    },

    getters: {},

    modules: {},
};
